/* eslint-disable */

/** unique or primary key constraints on table "argo.attribute_schema" */
export enum ArgoAttributeSchemaConstraint {
  /** unique or primary key constraint on columns "context_id", "type", "name_unique" */
  AttributeSchemaEnforceUnique = 'attribute_schema_enforce_unique',
  /** unique or primary key constraint on columns "attribute_schema_id" */
  AttributeSchemaPkey = 'attribute_schema_pkey'
}

/** select columns of table "argo.attribute_schema" */
export enum ArgoAttributeSchemaSelectColumn {
  /** column name */
  Color = 'color',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_attribute_schema_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.attribute_schema" */
export enum ArgoAttributeSchemaSelectColumnArgoAttributeSchemaAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_attribute_schema_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.attribute_schema" */
export enum ArgoAttributeSchemaSelectColumnArgoAttributeSchemaAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** update columns of table "argo.attribute_schema" */
export enum ArgoAttributeSchemaUpdateColumn {
  /** column name */
  Color = 'color',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

